import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CheckIsNull } from "../../../../utils/CommonHelper";
import * as actions from "../../redux/PromotionAction";
import { FreePromotionList } from "./FreePromotionList";

export const PromotionDetailModal = ({
  promotionId,
  setSwalProps,
  setPromotionId,
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [itemId, setItemId] = useState();
  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  useEffect(() => {
    if (promotionId) {
      const params = {
        action: "promotiondetailV2",
        promotionid: promotionId,
      };

      dispatch(actions.getPromotionDetail(params));
    }
  }, [promotionId]);

  return (
    <>
      <FreePromotionList
        itemId={itemId}
        freeCreditCompanyLists={
          promotionState.promotionDetail?.freeCreditCompanyLists
        }
        setItemId={setItemId}
        promotionId={promotionId}
        setSwalProps={setSwalProps}
      />
      <Modal
        onHide={() => setPromotionId(undefined)}
        show={!!promotionId}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        data-bs-theme="dark"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-white"
          >
            {promotionState.promotionDetail?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-white d-flex flex-column gap-2 py-2">
          {promotionState.promotionDetail?.title ? (
            <div>
              {!CheckIsNull(promotionState.promotionDetail?.imageurl) && (
                <div>
                  <img
                    alt={promotionState.promotionDetail?.promotiontitle}
                    src={promotionState.promotionDetail?.imageurl}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
              {promotionState.promotionDetail?.content !== "" && (
                <div className="mb-2" style={{ whiteSpace: "pre-line" }}>
                  {promotionState.promotionDetail?.content}
                </div>
              )}
              {promotionState.promotionDetail?.isclaimdirect === "true" && (
                <div className="d-flex flex-column gap-2">
                  {promotionState.promotionDetail?.freeCreditLists?.length >
                  0 ? (
                    promotionState.promotionDetail?.freeCreditLists.map(
                      (freeCreditList) => (
                        <div
                          className="rounded shadow-lg px-2 py-1 d-flex align-items-center justify-content-between"
                          style={{ background: "#323438" }}
                          key={freeCreditList.itemid}
                        >
                          <div>
                            <div className="fw-semibold">
                              {intl.formatMessage({ id: "free" })} :{" "}
                              {freeCreditList.freeamount}
                            </div>
                            <div
                              className="text-muted mt-1"
                              style={{ fontSize: "10px" }}
                            >
                              {freeCreditList.gentdate}
                            </div>
                          </div>
                          <div>
                            <button
                              className="rounded px-2"
                              type="button"
                              onClick={() => {
                                setItemId(freeCreditList.itemid);
                              }}
                              disabled={freeCreditList.claimded === "true"}
                              style={
                                freeCreditList.claimded === "true"
                                  ? {
                                      background: "#5c5c5c",
                                      color: "#fff",
                                      border: "none",
                                    }
                                  : {
                                      background: "#02b028",
                                      color: "#fff",
                                      border: "2px solid #34bf52",
                                    }
                              }
                            >
                              {intl.formatMessage({ id: "claim" })}
                            </button>
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div className="text-center">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <Skeleton className="w-100" style={{ height: "500px" }} />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
